/**
 * ESOS API Documentation
 * ESOS API Documentation
 *
 * The version of the OpenAPI document: uk-esos-app-api 0.81.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
import { OperatorInvitedUserInfoDTO } from '../model/operatorInvitedUserInfoDTO';
import { OperatorUserDTO } from '../model/operatorUserDTO';
import { OperatorUserInviteAndRegisterDTO } from '../model/operatorUserInviteAndRegisterDTO';
import { OperatorUserRegistrationDTO } from '../model/operatorUserRegistrationDTO';
import { TokenDTO } from '../model/tokenDTO';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class OperatorUsersRegistrationService {
  protected basePath = 'http://localhost:8080/api';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Accept invitation for operator user
   * @param tokenDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptOperatorInvitation(tokenDTO: TokenDTO): Observable<OperatorInvitedUserInfoDTO>;
  public acceptOperatorInvitation(
    tokenDTO: TokenDTO,
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<OperatorInvitedUserInfoDTO>>;
  public acceptOperatorInvitation(
    tokenDTO: TokenDTO,
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<OperatorInvitedUserInfoDTO>>;
  public acceptOperatorInvitation(
    tokenDTO: TokenDTO,
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<OperatorInvitedUserInfoDTO>;
  public acceptOperatorInvitation(
    tokenDTO: TokenDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (tokenDTO === null || tokenDTO === undefined) {
      throw new Error('Required parameter tokenDTO was null or undefined when calling acceptOperatorInvitation.');
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<OperatorInvitedUserInfoDTO>(
      `${this.configuration.basePath}/v1.0/operator-users/registration/accept-invitation`,
      tokenDTO,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Accept invitation and register for operator user
   * @param operatorUserInviteAndRegisterDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptOperatorInvitationAndRegister(
    operatorUserInviteAndRegisterDTO: OperatorUserInviteAndRegisterDTO,
  ): Observable<OperatorInvitedUserInfoDTO>;
  public acceptOperatorInvitationAndRegister(
    operatorUserInviteAndRegisterDTO: OperatorUserInviteAndRegisterDTO,
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<OperatorInvitedUserInfoDTO>>;
  public acceptOperatorInvitationAndRegister(
    operatorUserInviteAndRegisterDTO: OperatorUserInviteAndRegisterDTO,
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<OperatorInvitedUserInfoDTO>>;
  public acceptOperatorInvitationAndRegister(
    operatorUserInviteAndRegisterDTO: OperatorUserInviteAndRegisterDTO,
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<OperatorInvitedUserInfoDTO>;
  public acceptOperatorInvitationAndRegister(
    operatorUserInviteAndRegisterDTO: OperatorUserInviteAndRegisterDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (operatorUserInviteAndRegisterDTO === null || operatorUserInviteAndRegisterDTO === undefined) {
      throw new Error(
        'Required parameter operatorUserInviteAndRegisterDTO was null or undefined when calling acceptOperatorInvitationAndRegister.',
      );
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<OperatorInvitedUserInfoDTO>(
      `${this.configuration.basePath}/v1.0/operator-users/registration/accept-invitation-and-register`,
      operatorUserInviteAndRegisterDTO,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Register a new operator user
   * @param operatorUserRegistrationDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public registerCurrentOperatorUser(
    operatorUserRegistrationDTO: OperatorUserRegistrationDTO,
  ): Observable<OperatorUserDTO>;
  public registerCurrentOperatorUser(
    operatorUserRegistrationDTO: OperatorUserRegistrationDTO,
    observe: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<OperatorUserDTO>>;
  public registerCurrentOperatorUser(
    operatorUserRegistrationDTO: OperatorUserRegistrationDTO,
    observe: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<OperatorUserDTO>>;
  public registerCurrentOperatorUser(
    operatorUserRegistrationDTO: OperatorUserRegistrationDTO,
    observe: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<OperatorUserDTO>;
  public registerCurrentOperatorUser(
    operatorUserRegistrationDTO: OperatorUserRegistrationDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    if (operatorUserRegistrationDTO === null || operatorUserRegistrationDTO === undefined) {
      throw new Error(
        'Required parameter operatorUserRegistrationDTO was null or undefined when calling registerCurrentOperatorUser.',
      );
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType_ = 'text';
    }

    return this.httpClient.post<OperatorUserDTO>(
      `${this.configuration.basePath}/v1.0/operator-users/registration/register`,
      operatorUserRegistrationDTO,
      {
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
